export default {
	"lang": "cn",
	"page-title": "市场分析",
}